import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=79173abc&scoped=true&lang=html"
import script from "./Point.vue?vue&type=script&lang=js"
export * from "./Point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79173abc",
  null
  
)

export default component.exports